import React from "react";
import classNames from "classnames";

import { useRetrieveWbsMeta } from "@planzone/view-models";

import {
  isList,
  isProject,
  isTask,
} from "../../../graph/elementsOverlay/element/utils";
import { Props } from "./types";
import styles from "./styles.scss";
import { AllocationUnit } from "@common/allocationUnit";

function toFixed(nbr: number) {
  return typeof nbr === "number" || !isNaN(parseFloat(nbr))
    ? Math.round(nbr) === nbr
      ? nbr
      : nbr.toFixed(2)
    : "";
}

function Progress({ projects, element }: Props) {
  const { meta } = useRetrieveWbsMeta(projects);
  const canHaveAllocatedTime =
    isTask(element) || isProject(element) || isList(element);
  const elementMeta = meta[element.uuid] || {
    uuid: "",
    allocatedHours: 0,
    attachmentCount: 0,
    commentCount: 0,
    elementCount: 0,
    duration: 0,
    percentComplete: 0,
    spentHours: 0,
  };

  return (
    <div
      className={classNames(styles.details, {
        [styles.list]: isList(element),
        [styles.project]: isProject(element),
      })}
    >
      <div className={styles.block}>
        <p className={styles.text}>
          {canHaveAllocatedTime ? (
            <>
              {toFixed(elementMeta.allocatedHours)}
              <AllocationUnit
                amount={elementMeta.allocatedHours}
                format="symbol"
              />
            </>
          ) : (
            "-"
          )}
        </p>
      </div>
      <div className={styles.block}>
        <p className={styles.text}>
          {canHaveAllocatedTime ? (
            <>
              {toFixed(elementMeta.spentHours)}
              <AllocationUnit amount={elementMeta.spentHours} format="symbol" />
            </>
          ) : (
            "-"
          )}
        </p>
      </div>
      <div className={styles.block}>
        <p className={styles.text}>{toFixed(elementMeta.percentComplete)}%</p>
      </div>
    </div>
  );
}

export { Progress };
